<template>
    <div>
        <div v-if="pageLoading" class="d-flex" style="margin-top: 64px">
            <v-progress-circular color="primary" width="2" size="80" indeterminate/>
        </div>
        <div v-else-if="pageError">
            <div style="margin-top: 64px; text-align: center">{{ pageError }}</div>
            <div class="mt-4" style="text-align: center">
                <v-btn color="primary" @click="initPage">重试</v-btn>
            </div>
        </div>
        <div v-else-if="wrongRole">
            <div class="subheading px-3 pb-3 mt-4" style="text-align: center">您无需预约，请直接使用个人二维码刷码入校
            </div>
            <div class="mb-2" style="text-align: center">
                <v-btn color="primary" @click="goToSignCode">前往个人二维码</v-btn>
            </div>
        </div>
        <div v-else style="background-color: white; min-height: 100vh">
            <div class="title pa-4" style="text-align: center;">预约开放时段</div>
            <div class=" pt-4">
                <!--                <template>-->
                <!--                    <div>-->
                <!--                        <span>{{ rule.startDatetime }}</span>-->
                <!--                        <span class="mx-2">-</span>-->
                <!--                        <span>{{ rule.endDatetime }}</span>-->
                <!--                    </div>-->
                <!--                    <div>-->
                <!--                        <div v-for="g in rule.gateways" :key="g.id">-->
                <!--                            <span>{{g.name}}</span>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </template>-->
                <div class="px-4" style="font-size: 16px;" v-for="(s, i) in rule.slices" :key="i">
                    <div class="mb-4">
                        <template v-if="s.startWeekday">
                            <span>{{ $L.time.showWeekday(s.startWeekday) }}</span>
                            <span class="mx-2"></span>
                        </template>
                        <span>{{ s.startTime }}</span>
                        <span class="mx-2">-</span>
                        <template v-if="s.endWeekday">
                            <span>{{ $L.time.showWeekday(s.endWeekday) }}</span>
                            <span class="mx-2"></span>
                        </template>
                        <span class="mr-4">{{ s.endTime }}</span>

                        <template v-for="(g, j) in s.gateways">
                            <span :key="g.id">{{ g.name }}</span>
                            <span v-if="j !== s.gateways.length - 1" :key="g.id + '|'" class="pr-1">,</span>
                        </template>
                    </div>
                </div>
                <!--                <LPassRuleList no-ident single-rule pass-type="person" :pass-rules="rules"></LPassRuleList>-->
                <div v-if="allPlates.length > 0">
                    <!--            <div class="title pa-4" style="text-align: center;">当前通行规则</div>-->
                    <div class="title px-3 pb-3 mt-4 pt-4" style="text-align: center">
                        <div>已预约车牌</div>
                    </div>
                    <div class="body-2 px-4">{{allPlates.join(', ')}}</div>
                </div>
                <div class="pa-4 mt-4">
                    <v-form ref="form">
                        <v-text-field box v-model="plate" label="添加车牌" :rules="plateRules"/>
                    </v-form>
                </div>
            </div>
            <div class="mt-4" style="text-align: center">
                <v-btn :loading="makeLoading" @click="makeReservation" color="primary">立即预约</v-btn>
            </div>
        </div>
        <v-dialog v-model="confirmDialog.activated" width="600" persistent scrollable>
            <v-card>
                <v-card-title class="pa-0" style="display: flex; justify-content: center; align-content: center; height: 56px">
                    <h3>{{ confirmDialog.title }}</h3>
                </v-card-title>
                <v-card-text class="text--primary mt-0 pt-0">
                    <div
                        style="white-space: pre-wrap"
                        v-text="confirmDialog.msg"
                    />
                    <div class="text-center mt-4" style="display: flex;justify-content: center">
                        <v-btn
                            color="primary"
                            style="display: inline-block"
                            @click="confirmDialog.activated = false"
                        >同意
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import LPassRuleList from "@/components/LPassRuleList.vue";
import {PassRule} from "@/object";
import axios from "axios";
import {handleError} from "@/store/handleError";
import reg from '@/utils/reg';

const msg =
    `
校外访客：

进校后请做好个人安全管理、行责自负，并自觉遵守国家法律法规和学校相关管理规定，如有违反管理规定、扰乱校园秩序或其他影响校园安全情形的，学校保留追究相关人员或机构法律责任的权利。涉嫌违法的，将移交公安机关处理。
`

const title = '预约须知'

export default {
    name: "selfServiceReservation",
    components: {LPassRuleList},
    data: () => ({
        pageLoading: false,
        makeLoading: false,
        pageError: '',
        wrongRole: false,
        isOrder: false,
        rule: new PassRule(),
        plate: '',
        currentRules: [],
        allPlates: [],
        plateRules: [
            v => {
                return (v && reg.PLATE_PATTERN.test(v.trim())) || '车牌格式错误'
            }
        ],
        confirmDialog: {
            activated: true,
            msg,
            title,
        },
    }),
    computed: {
        controllerList() {
            return this.$store.state.parkingLot.controllerList
        },
    },
    async mounted() {
        this.initPage()
    },
    methods: {
        async initPage() {
            this.pageLoading = true
            try {
                this.pageError = ''
                this.wrongRole = false
                await this.$store.dispatch('login/initSystemInfo', false)
                const regCode = this.$store.state.login.self.regCode
                // if (regCode !== 615) {   // 访客
                //     this.wrongRole = true
                //     // this.pageError = '您无需预约，请直接使用个人二维码刷码入校'
                //     this.pageLoading = false
                //     return
                // }
            } catch (e) {
                this.pageLoading = false
                this.pageError = '加载系统信息错误，请退出重试'
                return
            }
            this.refreshInfo()
        },
        goToSignCode() {
            this.$router.replace({name: 'qrcode_gen'})
        },
        async refreshInfo() {
            let url = '/passApi/order/visitor/self/config'
            try {
                this.pageLoading = true
                this.pageError = ''
                let res = null
                res = await axios.get(url)
                if (res.data && +res.data.status === 1) {
                    this.isOrder = res.data.data.isOrder
                    this.allPlates = res.data.data.allNumberPlates
                    const rule = PassRule.fromAPI(res.data.data, this.controllerList)
                    rule.active = true
                    rule.slices.forEach(s => s.active = true)
                    // console.log('rule', rule)
                    this.rule = rule
                    if (this.isOrder) {
                        const rules = res.data.data.passRules
                        if (rules instanceof Array) {
                            this.currentRules = rules.map(r => PassRule.fromAPI(r, this.controllerList))
                            if (this.currentRules.length <= 3) {
                                this.currentRules.forEach(r => r.active = true)
                            }
                        }
                    }
                } else if (res.data.status === -2) {
                    throw new Error('仅限访客和校友使用')
                }
                else {
                    // throw Error('错误')
                    throw handleError(res.data)
                }
            } catch (e) {
                // this.$L.alert('error', e.message)
                this.pageError = e.message
            } finally {
                this.pageLoading = false
            }
        },
        async makeReservation() {
            try {
                const result = this.$refs.form.validate()
                if (!result) return

                this.makeLoading = true
                let url = `/passApi/order/self?numberPlate=${this.plate}`
                let res = null
                res = await axios.post(url)
                if (res.data && +res.data.status === 1) {
                    this.$L.alert('success', '预约成功')
                    this.refreshInfo()
                } else {
                    throw handleError(res.data)
                }
            } catch (e) {
                this.$L.alert('error', e.message)
            } finally {
                this.makeLoading = false
            }
        }
    }
}
</script>

<style scoped>

</style>
